import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { images } from "@/i18n/translations";
import { Reveal } from "@/components/site/Reveal";

export const Manifesto = () => {
  const { t } = useLang();
  const m = t.manifesto;
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="manifesto"
      ref={ref}
      data-testid="manifesto-section"
      className="relative bg-bone py-28 md:py-40"
    >
      <div className="mx-auto grid max-w-[1500px] grid-cols-1 gap-16 px-5 md:px-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-24">
        {/* Sticky spotlight image */}
        <div className="relative">
          <div className="lg:sticky lg:top-28">
            <Reveal className="relative aspect-[3/4] overflow-hidden">
              <motion.img
                style={{ y: imgY, scale: 1.15 }}
                src={images.manifesto}
                alt="Misty stubble field at dawn"
                className="h-full w-full object-cover will-change-transform"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/40 to-transparent" />
              <span className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.3em] text-bone/90">
                {m.overline} — Câmpia Română
              </span>
            </Reveal>
          </div>
        </div>

        {/* Chapters */}
        <div>
          <Reveal>
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-olive">
              {m.overline}
            </span>
            <h2 className="mt-5 max-w-xl font-display text-4xl font-medium uppercase leading-[0.95] tracking-tight text-ink md:text-6xl">
              {m.title}
            </h2>
          </Reveal>

          <div className="mt-14 flex flex-col">
            {m.chapters.map((c, i) => (
              <Reveal
                key={c.no}
                delay={i * 0.08}
                data-testid={`manifesto-chapter-${c.no}`}
                className="grid grid-cols-[auto_1fr] gap-6 border-t border-hairline py-8 md:gap-10"
              >
                <span className="font-display text-3xl font-medium text-rust md:text-4xl">
                  {c.no}
                </span>
                <div>
                  <h3 className="font-display text-2xl font-medium uppercase tracking-wide text-ink md:text-3xl">
                    {c.title}
                  </h3>
                  <p className="mt-3 max-w-lg font-body text-base leading-relaxed text-stone">
                    {c.body}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
